import router from '@/router/index'

const localStorageKey = 'AG_TABLE_CUSTOM_PAGE_SIZE'
const storage = JSON.parse(localStorage.getItem(localStorageKey) || '{}')

const useAgPageSize = (keyName, defaultSize = 100) => {
  const storageKey = (`${router.currentRoute.path}_${keyName}`).toLocaleUpperCase()

  if (!storage[storageKey]) {
    storage[storageKey] = defaultSize
    localStorage.setItem(localStorageKey, JSON.stringify(storage))
  }

  const obj = {}

  let objVal = storage[storageKey]

  Object.defineProperty(obj, 'value', {
    enumerable: true,
    configurable: true,
    get () {
      return objVal
    },
    set (newValue) {
      storage[storageKey] = newValue
      localStorage.setItem(localStorageKey, JSON.stringify(storage))
      objVal = newValue
    }
  })
  return obj
}

export default useAgPageSize
